let swipers = {
    productImage: {
        slider: false,
        elem: $(".js-slider-product-image"),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            pagination: {
                el: ".js-slider-product-image-dots",
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 16,
            },
            navigation: {
                nextEl: ".js-slider-product-image-next",
                prevEl: ".js-slider-product-image-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-hidden",
            },
            breakpoints: {
                1199: {
                    pagination: {
                        el: ".js-slider-product-image-dots",
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 8,
                    },
                },
                1023: {
                    spaceBetween: 30,
                    pagination: {
                        el: ".js-slider-product-image-dots",
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 14,
                    },
                },
                599: {
                    spaceBetween: 20,
                    pagination: {
                        el: ".js-slider-product-image-dots",
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 10,
                    },
                },
                359: {
                    spaceBetween: 15,
                    pagination: {
                        el: ".js-slider-product-image-dots",
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 8,
                    },
                },
            },
            on: {
                init: function () {
                    swipers.productImage.active = true;
                },
                slideChange: function () {
                    setTimeout(() => {
                        bLazy.revalidate();
                    }, 250);
                },
            },
        },
    },
    promotionProducts: {
        slider: false,
        elem: $(".js-promotion-products"),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
            simulateTouch: false,
            roundLengths: true,
            navigation: {
                nextEl: ".js-promotion-products-next",
                prevEl: ".js-promotion-products-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-hidden",
            },
            breakpoints: {
                1439: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1199: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                767: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                    freeMode: true,
                },
                599: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                    freeMode: true,
                },
                359: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    freeMode: true,
                },
            },
            on: {
                init: function () {
                    swipers.promotionProducts.active = true;
                },
            },
        },
    },
    accessoriesTab: {
        slider: false,
        elem: $(".js-tab-accessories"),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
            roundLengths: true,
            navigation: {
                nextEl: ".js-tab-accessories-next",
                prevEl: ".js-tab-accessories-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-hidden",
            },
            breakpoints: {
                1439: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1199: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                767: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30,
                    freeMode: true,
                },
                599: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 20,
                    slidesOffsetAfter: 20,
                    freeMode: true,
                },
                359: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15,
                    freeMode: true,
                },
            },
            on: {
                init: function () {
                    swipers.accessoriesTab.active = true;
                },
            },
        },
    },
    products: globalSwipers.products,
};

function floatingBoxInit(selector, query) {
    const $box = $(selector),
        $boxWrapper = $box.parent();

    floatingBoxFloat($box, $boxWrapper, query);

    $(window).on("scroll resize", function () {
        floatingBoxFloat($box, $boxWrapper, query);
    });

    rEvent.on("Product.variationChanged", function (data) {
        floatingBoxFloat($box, $boxWrapper, query);
    });
}

function floatingBoxFloat($box, $boxWrapper, query) {
    if (checkResolution(query)) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperWidth = $boxWrapper.width(),
            boxHeight = $box.outerHeight(),
            scrollOffset = 50,
            boxWrapperHeight = $boxWrapper.height();

        let boxStartScroll = 0,
            boxEndScroll = 0;

        if (boxWrapperHeight > boxHeight) {
            $box.addClass("is-absolute").addClass("is-visible");

            // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
            (boxStartScroll = windowTopOffset + scrollOffset),
                // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
                (boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHeight);

            // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
            // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
            // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
            // vtedy sa prida position fixed
            if (boxStartScroll > boxWrapperTopOffset && boxStartScroll < boxEndScroll) {
                $box.css("top", scrollOffset).css("width", boxWrapperWidth);
                $box.addClass("is-fixed");

                // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
                // posunie uplne na spodok wrapperu
            } else if (boxStartScroll > boxEndScroll) {
                $box.css("top", boxEndScroll - boxWrapperTopOffset).css("width", "");
                $box.removeClass("is-fixed");

                // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
                // uplne na vrch wrapperu
            } else if (boxStartScroll < boxWrapperTopOffset) {
                $box.css("top", boxWrapperTopOffset - boxWrapperTopOffset).css("width", "");
                $box.removeClass("is-fixed").removeClass("is-visible");
            }
        } else {
            $box.removeClass("is-absolute").removeClass("is-fixed");
        }
    } else {
        $box.removeClass("is-absolute").removeClass("is-fixed").css("width", "").css("top", "");
    }
}

function toggleDescLink($elem) {
    var $wrapper = $elem.find(".toggle_text__wrapper"),
        max_height = $wrapper.height(),
        real_height = $wrapper.children("div").height(),
        $link = $elem.find(".link__more");

    if (!$wrapper.hasClass("full")) {
        if (real_height > max_height) {
            $wrapper.addClass("is-collapsed");
            $link.show();
        }
    }
}

function updateProductShippingInfo(response) {
    if (!response.free_shipping) {
        return;
    }

    const $shippingInfo = $(".js-shipping-info"),
        $shippingFreeInfo = $(".js-shipping-info-free"),
        $shippingIcon = $shippingInfo.find(".is-icon"),
        $shippingText = $shippingInfo.find(".is-text"),
        $shippingFreeText = $shippingFreeInfo.find(".is-text"),
        price = response.free_shipping.price,
        cheapestShipping = response.free_shipping.cheapest_shipping;

    if ($shippingInfo.length) {
        $shippingIcon.toggleClass("is-free", price <= 0);
        $shippingText.html(
            $shippingInfo
                .data(price > 0 ? "text" : "text-free")
                .replace(":freeShippingAmount", Format.price(price))
                .replace(":shippingMinPrice", Format.price(cheapestShipping))
        );
    }

    if ($shippingFreeInfo.length) {
        $shippingFreeText.html(
            $shippingFreeInfo
                .data(price > 0 ? "text" : "text-free")
                .replace(":shippingMinPrice", Format.price(cheapestShipping))
        );
    }
}
Cart.customCallbacks.addedItem = function (form, response) {
    updateProductShippingInfo(response);
};

Cart.customCallbacks.updatedItem = function (input, response) {
    updateProductShippingInfo(response);
};

rEvent.on("Cart.removedProduct", function (data) {
    updateProductShippingInfo(data.response);
});

Cart.customCallbacks.removedItem = function (form, response) {
    updateProductShippingInfo(response);
};

$(function () {
    floatingBoxInit(".js-detail-thumb-floater", "md;lg");
    checkSliders(swipers);

    $(".js-detail-jpictura").jpictura({
        selectors: {
            item: ".is-photo",
        },
        layout: {
            itemSpacing: 16,
            minWidthHeightRatio: 1 / 2,
            maxWidthHeightRatio: 2,
        },
        responsive: {
            containerResizeInterval: 25,
            debounce: 50,
        },
        waitForImages: false,
    });

    tippy(".js-detail-action-tippy", {
        arrow: true,
        animation: "shift-away",
        placement: "left",
        theme: "thumb-action",
        duration: [300, 180],
        inertia: true,
        onShow(instance) {
            if (checkResolution("xs;cxs")) {
                // this._tippy.hide();

                setTimeout(() => {
                    instance.hide();
                }, 1);
            }
        },
    });

    tippy(".js-detail-share-tippy", {
        arrow: true,
        interactive: true,
        interactiveBorder: 24,
        hideOnClick: false,
        animation: "shift-away",
        placement: "bottom-start",
        theme: "detail-share",
        duration: [300, 180],
        inertia: true,
        html: ".js-detail-share-content",
    });

    tippy(".js-tippy-floater-actions", {
        arrow: true,
        interactive: true,
        interactiveBorder: 24,
        hideOnClick: false,
        animation: "shift-away",
        placement: "bottom-end",
        theme: "detail-share",
        duration: [300, 180],
        inertia: true,
        html: ".js-tippy-floater-content",
    });

    $(".js-slider-product-image").lightGallery(
        $.extend({}, lightGallerySettings, {
            thumbnail: true,
            selector: ".js-lightbox",
            exThumbImage: "data-thumb",
            galleryId: 1,
            zoom: true,
        })
    );

    $(".js-lightbox").css("pointer-events", "auto");

    $(".js-tippy-floater-actions").on("click", function (event) {
        event.preventDefault();
    });

    $('a[href="#section_product_accessories"]').on("shown.bs.tab", function (e) {
        setTimeout(function () {
            swipers.accessoriesTab.slider.update();
        }, 5);
    });

    $(".js-detail-tabs-trigger").on("shown.bs.tab", function (e) {
        $(".js-detail-tabs-trigger").removeClass("is-active");
        $(e.target).addClass("is-active");

        setTimeout(function () {
            slideTo($(e.target), 0, 150);
        }, 5);
    });

    $(".js-detail-tabs-trigger").on("click", function (e) {
        if ($(this).hasClass("is-active")) {
            e.preventDefault();
            e.stopPropagation();

            $(this).removeClass("is-active");
            $(this).next(".tab-pane").removeClass("active");
        }
    });

    $(".js-show-tab").on("click", function () {
        const tabName = $(this).data("tab");

        $(`a[data-toggle="tab"][href="#${tabName}"]:visible`).trigger("click");

        if ($(".js-detail-tabs-header").is(":visible")) {
            setTimeout(function () {
                slideTo($(".js-detail-tabs-header"), 0, 150);
            }, 5);
        }
    });

    $(".js-gallery-more").on("click", function (e) {
        e.preventDefault();

        $(".js-slider-product-image").find(".js-lightbox").first().trigger("click");
    });

    $(".js-lightbox-fake").on("click", function (e) {
        const index = $(this).index();

        e.preventDefault();

        $(".js-slider-product-image").find(".js-lightbox").eq(index).trigger("click");
    });

    $(".toggle_text").each(function () {
        toggleDescLink($(this));
    });

    $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        $(".toggle_text").each(function () {
            toggleDescLink($(this));
        });

        bLazy.revalidate();
    });

    $("body").on("click", ".toggle_text .link__more", function (event) {
        var $this = $(this),
            $desc = $this.siblings(".toggle_text__wrapper");

        event.preventDefault();

        $desc.toggleClass("is-collapsed");
        $desc.addClass("full");
        $this.hide();
    });

    $(".js-play-video").on("click", function () {
        const $iframe = $(this).next(),
            src = $iframe.data("src");

        $iframe.attr("src", src);

        $(this).remove();
    });

    rEvent.on("Window.resized", function () {
        checkSliders(swipers);
    });

    createStars($(".js-product-rating-stars"), {
        readOnly: false,
        starSize: 25,
        initialRating: 5,
        callback: function (currentRating, $el) {
            $(".js-product-rating-stars-input").val(currentRating);
        },
    });

    $(".js-product-rating-form").validate({
        rules: {
            "login-reg": {
                required: true,
                email: true,
            },
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass("is-loading").prop("disabled", true);

            var $productRatingMessage = $(".js-product-rating-message");
            $productRatingMessage.slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(function () {
                Form.ajaxPost(
                    form,
                    function (data) {
                        if (data.status) {
                            $(".js-product-rating-form").slideUp();
                        }

                        $productRatingMessage
                            .toggleClass("c-msg--error", !data.status)
                            .toggleClass("c-msg--success", data.status)
                            .text(data.message)
                            .slideDown();
                    },
                    "json"
                )
                    .fail(function () {
                        $productRatingMessage
                            .toggleClass("c-msg--error", true)
                            .toggleClass("c-msg--success", false)
                            .text($productRatingMessage.data("general-error"))
                            .slideDown();
                    })
                    .always(function () {
                        $(form)
                            .find('button[type="submit"]')
                            .removeClass("is-loading")
                            .prop("disabled", false);
                    });
            });
        },
    });

    $(".js-gallery-thumb").on("click", function (event) {
        event.preventDefault();

        $(".js-slider-product-image .js-lightbox").eq($(this).attr("data-id")).click();
    });

    $(document).on("click", ".tippy-tooltip .js-share-facebook", function () {
        $("#productShareFb").trigger("click");
    });

    $(document).on("click", ".js-share-twitter", function (e) {
        e.preventDefault();

        const data = $(this).data();

        window.open(
            "https://twitter.com/share?url=" + data.href + "&text=" + data.text,
            "_blank",
            "width=540,height=450,menubar=0"
        );
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("feedback_hash") || urlParams.has("new-rating")) {
        $("#newRating").modal("show");
    }
});
